import * as _ from 'lodash';
import React from 'react';

import { mix as mixStyles } from 'lib/style-util';

const COMPLEX_OVERRIDES = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true,
  },

  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true,
  },

  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true,
  },

  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true,
  },

  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true,
  },

  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true,
  },

  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true,
  },

  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true,
  },

  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true,
  },
};

const originalCreateElement = React.createElement;
React.createElement = function (type, props, ...args) {
  if (props && props.style === false) {
    props.style = undefined;
  }

  if (props && props.style && !props.__cachedStyles && _.isArray(props.style)) {
    const __cachedStyles = _.flattenDeep([props.style]);

    const styles = mixStyles(__cachedStyles);
    const finalStyles = {};

    _.keys(styles).forEach((key) => {
      const overrides = COMPLEX_OVERRIDES[key];

      if (overrides) {
        _.keys(overrides).forEach((overrideKey) => {
          props.style[overrideKey] = '';
        });
      }

      finalStyles[key] = styles[key];
    });

    props.style = finalStyles;
  }
  return originalCreateElement.apply(this, [type, props, ...args]);
};
